/**
 * PDFCaptureOverlay - Overlay for capture mode
 *
 * Extracted from PDFViewerModal.tsx
 */

import React from 'react';
import type { Theme } from '../../../themes/theme';
import type { CaptureRect } from '../hooks/usePDFCapture';

export interface PDFCaptureOverlayProps {
  theme: Theme;
  captureRect: CaptureRect | null;
  onMouseDown: (e: React.MouseEvent) => void;
  onMouseMove: (e: React.MouseEvent) => void;
  onMouseUp: () => void;
  onMouseLeave: () => void;
}

export function PDFCaptureOverlay({
  theme,
  captureRect,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseLeave,
}: PDFCaptureOverlayProps) {
  return (
    <div
      className="absolute inset-0 cursor-crosshair z-20"
      style={{
        backgroundColor: `rgb(var(--nb-accent-rgb) / 0.05)`,
        pointerEvents: 'auto',
      }}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
    >
      {captureRect && (
        <div
          className="absolute border-2 border-nb-focus"
          style={{
            left: `${captureRect.x}px`,
            top: `${captureRect.y}px`,
            width: `${captureRect.width}px`,
            height: `${captureRect.height}px`,
            backgroundColor: `rgb(var(--nb-accent-rgb) / 0.1)`,
            pointerEvents: 'none',
          }}
        />
      )}
      <div
        className={`absolute top-4 left-1/2 transform -translate-x-1/2 ${theme.colors.bg.primary} border ${theme.colors.border.primary} px-4 py-2.5 rounded-lg shadow-xl text-sm font-medium ${theme.colors.text.primary} flex items-center gap-2.5`}
        style={{ pointerEvents: 'none' }}
      >
        <span>📸</span>
        <span>Arrastra para seleccionar región</span>
        <span className={theme.colors.text.secondary}>•</span>
        <span className={theme.colors.text.secondary}>ESC para cancelar</span>
      </div>
    </div>
  );
}
